export default __webpack_public_path__ + "img/13.asset.d56c7a6d.jpeg";